var OCS = OCS || {};
OCS.Viewer = OCS.Viewer || {};
OCS.Viewer.Interfaces = OCS.Viewer.Interfaces || {};
OCS.Viewer.Functions = OCS.Viewer.Functions || {};
OCS.Viewer.Functions.define_layer_group_info_interface = function () {
    OCS.Viewer.Interfaces.LayerGroupInfo = {
        dataset_obj: null,
        map_datetime_obj: null,
        show_in_url: true,
        init_info_events: function () {
            this.addEvent('destroy_layer_group', this.destroy_info.bind(this));
            this.addEvent('add_dataset', this.set_dataset_obj.bind(this));
            this.addEvent('add_map_datetime_obj', this.set_map_datetime_obj.bind(this));
        },
        get_auto: function () {
            return this.options.auto;
        },
        set_dataset_obj: function (dataset) {
            if (dataset && dataset.class_type && dataset.class_type === "Dataset") {
                this.dataset_obj = dataset;
            } else {
                this.dataset_obj = new OCS.Viewer.Classes.Dataset();
            }
            this.removeEvents('add_dataset');
        },
        get_dataset_obj: function () {
            if (!this.dataset_obj) {
                var dataset = this.get_dataset();
                if (dataset && OCS.Datasets[dataset]) {
                    this.dataset_obj = OCS.Datasets[dataset];
                } else {
                    this.dataset_obj = new OCS.Classes.Dataset();
                }
            }
            return this.dataset_obj;
        },
        get_map_datetime_obj: function () {
            if (!this.map_datetime_obj) {
                this.set_map_datetime_obj(new OCS.Viewer.Classes.MapDateTime());
            }
            return this.map_datetime_obj;
        },
        set_map_datetime_obj: function (datetime_obj) {
            this.map_datetime_obj = datetime_obj;
            this.removeEvents('add_map_datetime_obj');
            this.fireEvent("map_datetime_obj_added", datetime_obj);
        },
        current_epoch_time: function () {
            var dateObj = this.get_map_datetime_obj();
            return dateObj.get_current_epoch_time();
        },
        get_layer_short_name: function () {
            if (this.options.layer_short_name) {
                return this.options.layer_short_name;
            }
            var short_name;
            var variables = this.get_variables();
            if (variables && variables.length) {
                var util = OCS.Viewer.Functions.get_utilities();
                short_name = util.get_parm_short_name(variables[0].parm).toLowerCase().capitalize();
            } else {
                short_name = "layer";
            }
            this.options.layer_short_name = short_name;
            return short_name;
        },
        get_layer_name: function () {
            if (!this.options.layer_name) {
                var dataset_obj = this.get_dataset_obj();
                var variables = this.get_variables();
                var class_type_array = this.options.layer_class.split("Layer");
                var class_type = class_type_array[class_type_array.length - 1];
                var parm_name = "";
                if (variables && variables.length) {
                    var util = OCS.Viewer.Functions.get_utilities();
                    parm_name = util.get_parm_name(variables[0].parm);
                }
                this.options.layer_name = dataset_obj.getOption("name") + " " + parm_name.toLowerCase().capitalize() + " " + class_type.toLowerCase().capitalize();
            }
            return this.options.layer_name;

        },
        is_static: function () {
            return this.options.static;
        },
        set_static: function (condition) {
            this.options.static = condition;
        },
        get_stale_threshold: function () {
            return this.get_dataset_obj().getOption("stale_threshold");
        },
        get_dataset: function () {
            return this.options.layer_source_ops.metadata.dataset;
        },
        get_datatype: function () {
            return this.get_dataset_obj().get_datatype();
        },
        get_resolution: function () {
            return this.get_dataset_obj().get_resolution();
        },
        get_variables: function () {
            return this.options.layer_source_ops.metadata.variables;
        },
        get_gridded: function () {
            return this.options.layer_source_ops.metadata.grid;
        },
        get_num_layers: function () {
            var num = 0;
            if (this.layers && OCS.Utilities.is_object(this.layers)) {
                num = Object.keys(this.layers).length;
            }
            return num;
        },
        get_layer_cat_type: function () {
            var layer_arr = ['gradient', 'shape', 'contour', 'point', 'radar', 'obs', 'vector'];
            return ($.inArray(this.options.layer_type, layer_arr) !== -1) ? this.options.layer_type : 'shape';
        },
        get_layer_type: function () {
            return this.options.layer_type;
        },
        get_layer_visibility_text: function () {
            return (this.is_visible()) ? 'on' : 'off';
        },
        get_source_type: function () {
            return this.options.layer_source_ops.metadata.source_type;
        },
        get_layer_source_options: function (metadata) {
            var source_ops = Object.clone(this.options.layer_source_ops);
            if (metadata) {
                var util = OCS.Viewer.Functions.get_utilities();
                source_ops = util.combine_objects(source_ops, Object.clone(metadata), {merge: true, deep: true});
            }
            return source_ops;
        },
        get_show_in_url: function () {
            return this.show_in_url;
        },
        is_visible: function () {
            var group = this.get_ol_object();
            return group.getVisible();
        },
        set_visible: function (condition) {
            this.options.visible = condition;
            if (this.get_active_layer) {
                var active_layer = this.get_active_layer();
                if (active_layer) {
                    active_layer.set_visible(condition);
                }
            }
            var group = this.get_ol_object();
            group.setVisible(condition);
        },
        destroy_info: function () {
            this.map_datetime_obj = null;
        }

    };
};
OCS.Viewer.Functions.define_layer_group_info_interface();